module.exports = __webpack_public_path__ + "static/wingman_pro-76f789d5ee13f1737601042ceece3c26.png";